import React from 'react';
import usePartners from './usePartners';

export default function useInactivePartners(state, network, schoolStart, schoolEnd, currentTimestamp) {
  return usePartners(state, network, schoolStart, schoolEnd, {
    inactive: true
  });
}
